import { useTranslation } from 'react-i18next';

import { CreateLocationModal } from '@thinknet-gmbh/platform-common-ui';

import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';
import { useCreateHolidayLocation } from 'src/hooks/holiday-manager/create-holiday-location.hook';

const CreateLocation = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation(['common', 'settings']);

  const createHolidayLocation = useCreateHolidayLocation({ onSuccess: onClose });
  const currentCompanyId = useGetCurrentCompanyId();

  const onFinish = (values: any) => {
    createHolidayLocation({ variables: { payload: { ...values, companyId: currentCompanyId } } });
  };

  return <CreateLocationModal onFinish={onFinish} onClose={onClose} t={t} />;
};

export default CreateLocation;
